if (!customElements.get('custom-faq')) {
  customElements.define(
    'custom-faq',
    class CustomFAQ extends HTMLElement{
      constructor(){
        super();
        this.radioForm = this.querySelector("#faq-radios");
        this.radioForm?.addEventListener('change',this.changeHandler.bind(this))
      }

      changeHandler(e){
        e.preventDefault();
        let name = e.target.id.split('faq--')[1];
        this.querySelector(`[data-faq-title].tab--active`)?.classList.remove('tab--active')
        this.querySelector(`[data-faq-title="${name}"]`)?.classList.add('tab--active')
      }
    }
  )
}